<template>
  <view class="service-desc-bar-container">
    <view class="service-name">
      <view class="name">{{serviceName}}</view>
      <spring-icon
        size="20"
        color="#999"
        name="circle-question-mark"
        externClass="question-mark"
        bindclick="openRightsDescDrawer"
      />
    </view>
    <view class="service-status">已开启</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {},
    data() {
      return {}
    },
    computed: {
      ...store.mapState({
        selectRightInfo: 'train.selectRightInfo'
      }),
      serviceName() {
        return this.selectRightInfo?.[0]?.title ?? ''
      }
    },
    methods: {
      openRightsDescDrawer() {
        this.triggerEvent('openRightsDescDrawer')
      }
    }
  })
</script>

<style scoped lang="stylus">
  .service-desc-bar-container
    background #fff
    margin-top 8px
    border-radius 8px
    padding 16px
    padding-right 14px
    box-sizing border-box
    line-height 16px
    display flex
    justify-content space-between
    align-items center
    .service-name
      display flex
      align-items center
      .name
        font-size 16px
        font-family PingFangSC-Semibold
        font-weight 600
        color #333
      .question-mark
        margin-left 4px
    .service-status
      font-size 14px
      line-height 14px
      font-family PingFangSC-Regular
      font-weight 400
      color #999
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'spring-icon': '@didi/spring-icon'
    }
  }
</script>